import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40200c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container p-3 gutter--md" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row pb-4" }
const _hoisted_4 = { class: "large flex sm8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Notifi allows you to create proactive alerts for all the best protocols in Web3. Ad hoc alerts keep you updated on the latest happenings in your favorite platforms, while transactional alerts allow you to subscribe to individual events on the blockchain. Never miss a key event again - you can get a text message, email, or other alert whenever a transfer happens, a vote occurs, or a new proposal is approved on your favorite chains and protocols. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "pt-5 pb-5" }, "Login now to get started for free!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Proactive alerts help you keep ahead in DeFi! Simply stake tokens in these leading platforms for free access to updates and contract alerts for participating protocols! Stake your tokens to get access to proactive wallet alerts to keep an eye on your funds. ", -1))
const _hoisted_8 = { class: "flex sm4" }
const _hoisted_9 = {
  class: "layout gutter-md",
  style: {"max-width":"300px"}
}
const _hoisted_10 = { class: "row pb-3" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_13 = { class: "row" }

import Moralis from "moralis";
import { NotifiUser } from "../models/NotifiUser";
import { userModule } from "../store/user";
import { useUserStore } from "@/store/pinia_user";
import Footer from "@/components/footer.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();

const doLogin = async (): Promise<void> => {
  try {
    const user = await Moralis.authenticate({
      signingMessage: "Sign in to Notifi",
    });
    /*const user = await Moralis.authenticate({
          provider: "web3Auth",
          theme: "light",
          chainId: 0xa86a,
          clientId:
            "BNAltJRis6TNpbJxvM4WwENUZbgdzE5sGXZ8bCYYHEXlxTrtLVVxwe6WrX80y6IvH14l_clPo_Eqs7ay3TLGKow",
        });*/
    if (user) {
      const q = new Moralis.Query(NotifiUser);
      const newUser = await q.get(user.id);
      user.setACL(new Moralis.ACL(user));
      newUser.setACL(new Moralis.ACL(newUser));
      userModule.SET_USER(user);
      userStore.SET_USER(user);
      router.push({ name: "Home" });
    }
  } catch (error) {
    console.log({ error });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Header = _resolveComponent("Header")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_ProtocolSelector = _resolveComponent("ProtocolSelector")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_va_divider),
            _hoisted_6,
            _createVNode(_component_va_divider),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_va_button, {
                    color: "primary",
                    onClick: _withModifiers(doLogin, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_va_divider),
          _createVNode(_component_ProtocolSelector, {
            showSearch: true,
            showVote: false,
            showSubscribe: false,
            showUserInfo: false,
            showSearchFavorites: false,
            allowSelect: false,
            showStatus: true,
            showFavorites: false
          })
        ])
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})